<template>
  <div class="loader-animation-container">
    <div id="loader" class="overlay-loader" v-if="loading && tabEnabled">
      <div class="loader-background"></div>
      <div class="loading-svg">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px"
    x="0px" y="0px" viewBox="394 107 650 670" enable-background="new 394 107 650 670" xml:space="preserve">
        <g class="sub_one">
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="629,442.2 629,533 719.5,533
          719.6,533 	" />
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="720,533.4 720,442 628.3,442
          628.2,442 	" />
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="629,351 629,442 719.5,442 719.6,442
          " />
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="810.8,442 720,442 720,350.7
          720,350.6 	" />
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="719.6,351 811.6,351 811.6,441.9
          811.6,442 	" />
          <polygon fill="transparent" stroke="#fff" stroke-width="2" stroke-linejoin="bevel" points="719.6,442 811.6,442 811.6,533.2
          811.6,533.3 	" />
        </g>
        <g class="sub_three">
          <polygon fill="#00CB82" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="629,442.2 629,533 719.5,533
          719.6,533 	" />
          <polygon fill="#00E69D" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="720,533.4 720,442 628.3,442
          628.2,442 	" />
          <polygon fill="#00CB82" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="629,351 629,442 719.5,442 719.6,442
          " />
          <polygon fill="#00CB82" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="810.8,442 720,442 720,350.7
          720,350.6 	" />
          <polygon fill="#00E69D" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="719.6,351 811.6,351 811.6,441.9
          811.6,442 	" />
          <polygon fill="#00E69D" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="719.6,442 811.6,442 811.6,533.2
          811.6,533.3 	" />
        </g>
        <g class="sub_two">
          <polygon fill="#00CB82" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="629,442.2 629,533 719.5,533
          719.6,533 	" />
          <polygon fill="#00E69D" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="720,533.4 720,442 628.3,442
          628.2,442 	" />
          <polygon fill="#00CB82" stroke="#00CB82" stroke-width="2" stroke-linejoin="bevel" points="629,351 629,442 719.5,442 719.6,442
          " />
          <polygon fill="#00CB82" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="810.8,442 720,442 720,350.7
          720,350.6 	" />
          <polygon fill="#00E69D" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="719.6,351 811.6,351 811.6,441.9
          811.6,442 	" />
          <polygon fill="#00E69D" stroke="#00E69D" stroke-width="2" stroke-linejoin="bevel" points="719.6,442 811.6,442 811.6,533.2
          811.6,533.3 	" />
        </g>
        <g class="sub_four">
          <circle fill="#00CB82" cx="968.2" cy="389.2" r="5.2" />
          <circle fill="#00CB82" cx="988.9" cy="382.2" r="7.1" />
          <circle fill="#00CB82" cx="961.5" cy="363.8" r="4.3" />
          <circle fill="#00CB82" cx="945.6" cy="554.6" r="5.2" />
          <circle fill="#00CB82" cx="966.8" cy="560.1" r="7.1" />
          <circle fill="#00CB82" cx="954" cy="529.7" r="4.3" />
          <circle fill="#00CB82" cx="854.5" cy="660.9" r="5.2" />
          <circle fill="#00CB82" cx="868.5" cy="677.7" r="7.1" />
          <circle fill="#00CB82" cx="875.8" cy="645.5" r="4.3" />
          <circle fill="#00CB82" cx="712.2" cy="698.7" r="5.2" />
          <circle fill="#00CB82" cx="714" cy="720.4" r="7.1" />
          <circle fill="#00CB82" cx="738.6" cy="698.4" r="4.3" />
          <circle fill="#00CB82" cx="553" cy="645.2" r="5.2" />
          <circle fill="#00CB82" cx="542.2" cy="664.2" r="7.1" />
          <circle fill="#00CB82" cx="574.9" cy="659.6" r="4.3" />
          <circle fill="#00CB82" cx="470" cy="514.1" r="5.2" />
          <circle fill="#00CB82" cx="451.1" cy="525.1" r="7.1" />
          <circle fill="#00CB82" cx="481.6" cy="537.7" r="4.3" />
          <circle fill="#00CB82" cx="473.9" cy="358.8" r="5.2" />
          <circle fill="#00CB82" cx="452.3" cy="356.4" r="7.1" />
          <circle fill="#00CB82" cx="469.2" cy="384.6" r="4.3" />
          <circle fill="#00CB82" cx="562.4" cy="235.9" r="5.2" />
          <circle fill="#00CB82" cx="547.3" cy="220.1" r="7.1" />
          <circle fill="#00CB82" cx="542.1" cy="252.6" r="4.3" />
          <circle fill="#00CB82" cx="726.7" cy="185.4" r="5.2" />
          <circle fill="#00CB82" cx="724.8" cy="163.6" r="7.1" />
          <circle fill="#00CB82" cx="700.4" cy="185.8" r="4.3" />
          <circle fill="#00CB82" cx="887.9" cy="248.9" r="5.2" />
          <circle fill="#00CB82" cx="900.5" cy="231" r="7.1" />
          <circle fill="#00CB82" cx="867.6" cy="232.3" r="4.3" />
        </g>
      </svg>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'splash-screen',
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      tabEnabled: {
        type: Boolean,
        required: true
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
  .overlay-loader {
    color: white;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
  }

  .overlay-loader .loader-background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000;
    -webkit-transition: background-color .2s 0s linear, right .2s .3s ease-out;
    -moz-transition: background-color .2s 0s linear, right .2s .3s ease-out;
    -ms-transition: background-color .2s 0s linear, right .2s .3s ease-out;
    -o-transition: background-color .2s 0s linear, right .2s .3s ease-out;
    transition: background-color .2s 0s linear, right .2s .3s ease-out;
  }

  .loading-svg {
    position: relative;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
  }

  @keyframes grow_one {
    20% {
        opacity: 0;
        transform: scale(0);
    }
    21% {
        opacity: 0;
    }
    24% {
        opacity: 1;
        transform: scale(1);
    }
    60% {
        fill: #00CB82;
        stroke: #00CB82;
    }
    90% {
        fill: transparent;
        stroke: transparent;
    }
    100% {
        opacity: 1;
        fill: transparent;
        stroke: transparent;
        transform: scale(1);
    }
}

.sub_two polygon:nth-of-type(4),
.sub_two polygon:nth-of-type(3),
.sub_two polygon:nth-of-type(1) {
    opacity: 0;
    transform-origin: 715px 450px;
    transform: scale(0);
    animation: grow_one 2s ease-in infinite;
}

@keyframes grow_two {
    20% {
        opacity: 0;
        transform: scale(0);
    }
    21% {
        opacity: 0;
    }
    24% {
        opacity: 1;
        transform: scale(1);
    }
    60% {
        fill: #00E69D;
        stroke: #00E69D;
    }
    90% {
        fill: transparent;
        stroke: transparent;
    }
    100% {
        opacity: 1;
        fill: transparent;
        stroke: transparent;
        transform: scale(1);
    }
}

.sub_two polygon:nth-of-type(6) {
    opacity: 0;
    transform-origin: 715px 450px;
    transform: scale(0);
    animation: grow_two 2s ease-in infinite;
}

@keyframes grow_three {
    20% {
        opacity: 0;
        transform: scale(0);
    }
    21% {
        opacity: 0;
    }
    24% {
        opacity: 1;
        transform: scale(1);
    }
    60% {
        fill: #00E69D;
        stroke: #00E69D;
    }
    90% {
        fill: transparent;
        stroke: transparent;
    }
    100% {
        opacity: 1;
        fill: transparent;
        stroke: transparent;
        transform: scale(1);
    }
}

.sub_two polygon:nth-of-type(2) {
    opacity: 0;
    transform-origin: 715px 450px;
    transform: scale(0);
    animation: grow_four 2s ease-in infinite;
}

@keyframes grow_four {
    20% {
        opacity: 0;
        transform: scale(0);
    }
    21% {
        opacity: 0;
    }
    24% {
        opacity: 1;
        transform: scale(1);
    }
    60% {
        fill: #00E69D;
        stroke: #00E69D;
    }
    90% {
        fill: transparent;
        stroke: transparent;
    }
    100% {
        opacity: 1;
        fill: transparent;
        stroke: transparent;
        transform: scale(1);
    }
}

.sub_two polygon:nth-of-type(5) {
    opacity: 0;
    transform-origin: 715px 450px;
    transform: scale(0);
    animation: grow_four 2s ease-in infinite;
}

@keyframes pulsating_effect {
    20% {
        opacity: 0;
    }
    30% {
        opacity: 0.12;
    }
    40% {
        transform: scale(1.23);
    }
    70% {
        opacity: 0;
    }
    100% {
        opacity: 0;
        transform: scale(1.23);
    }
}

.sub_three {
    opacity: 0;
    transform-origin: 715px 450px;
    animation: pulsating_effect 2s ease-out infinite;
}

@keyframes burst {
    22% {
        transform: scale(0);
    }
    28% {
        opacity: .75;
        transform: scale(.9);
    }
    42% {
        transform: scale(1);
    }
    46% {
        opacity: 0;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(1);
    }
}

.sub_four {
    transform-origin: 715px 450px;
    transform: scale(0);
    animation: burst 2s ease-out infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/SplashScreen.vue